/**
 * Global locale registry (Uniswap-style i18n entry point).
 *
 * To add a language:
 * 1. Append a column to each row in `data.mjs` (column 0 = zh key, 1 = en, …).
 * 2. Add an entry here with matching `column` index.
 * 3. `short` 仅用于极窄位兜底；语言选择器折叠态显示 `native` 全称。
 */

/** @typedef {{ id: string, native: string, short: string, english: string, column: number }} LocaleDef */

/** @type {LocaleDef[]} */
export const LOCALES = [
  { id: 'zh', native: '简体中文', short: '中文', english: 'Chinese (Simplified)', column: 0 },
  { id: 'zh-TW', native: '繁體中文', short: '繁中', english: 'Chinese (Traditional)', column: 2 },
  { id: 'en', native: 'English', short: 'EN', english: 'English', column: 1 },
  { id: 'ja', native: '日本語', short: 'JP', english: 'Japanese', column: 3 },
  { id: 'ko', native: '한국어', short: 'KR', english: 'Korean', column: 4 },
  { id: 'es', native: 'Español', short: 'ES', english: 'Spanish', column: 5 },
  { id: 'pt-BR', native: 'Português (Brasil)', short: 'PT', english: 'Portuguese (Brazil)', column: 6 },
  { id: 'vi', native: 'Tiếng Việt', short: 'VI', english: 'Vietnamese', column: 7 },
  { id: 'fr', native: 'Français', short: 'FR', english: 'French', column: 8 },
]

export const LOCALE_IDS = LOCALES.map((l) => l.id)
export const DEFAULT_LOCALE = 'en'

export function getLocale(id) {
  return LOCALES.find((l) => l.id === id) || LOCALES.find((l) => l.id === DEFAULT_LOCALE)
}

/** @param {string} id @param {{ short?: boolean }} [opts] */
export function localeDisplay(id, { short = false } = {}) {
  const loc = getLocale(id)
  return short ? loc.short : loc.native
}

/** @param {string} id */
export function isChineseLocale(id) {
  return id === 'zh' || id === 'zh-TW'
}

/** @param {string} id */
export function intlLocaleFor(id) {
  if (id === 'zh') return 'zh-CN'
  if (id === 'zh-TW') return 'zh-TW'
  if (id === 'ja') return 'ja-JP'
  if (id === 'ko') return 'ko-KR'
  if (id === 'es') return 'es-ES'
  if (id === 'pt-BR') return 'pt-BR'
  if (id === 'vi') return 'vi-VN'
  if (id === 'fr') return 'fr-FR'
  return 'en-US'
}
